export default __webpack_public_path__ + "static/media/traumatismo_encefalo_craneano_pediatria.c98317f5.pdf";